import type { FontFamily } from "./FontFamily";

export function fontFamilyCSS(fontFamily: FontFamily) {
  const variableSuffix = fontFamily.replaceAll(" ", "-").toLowerCase();

  return {
    "--litesite-font-family": `var(--font-${variableSuffix}, "${fontFamily}", "Poppins", sans-serif)`,
  };
}
